import InlineAlert from 'src/components/primitives/InlineAlert/InlineAlert';
import Button from 'src/components/primitives/Button/Button';
import { printDate } from 'src/utils/dateTime';
import { SpotMarketConfig } from '@drift-labs/sdk';

interface Props {
	hasExistingUnstakeRequest: boolean;
	canWithdraw: boolean;
	existingUnstakeRequestAmount: number;
	existingUnstakeRequestTimestamp: Date;
	displayPrecision: number;
	selectedMarket: SpotMarketConfig;
	isSubmitting: boolean;
	handleWithdrawUnstakedAssets: () => void;
	handleCancelUnstakeRequest: () => void;
}

export default function UnstakeRequestInlineAlert({
	hasExistingUnstakeRequest,
	canWithdraw,
	existingUnstakeRequestAmount,
	existingUnstakeRequestTimestamp,
	displayPrecision,
	selectedMarket,
	isSubmitting,
	handleWithdrawUnstakedAssets,
	handleCancelUnstakeRequest,
}: Props) {
	if (!hasExistingUnstakeRequest) {
		return null;
	}

	if (canWithdraw) {
		return (
			<InlineAlert variant="success" title="Ready to withdraw">
				You have {existingUnstakeRequestAmount?.toFixed(displayPrecision)}
				{selectedMarket.symbol} unstaked and ready to withdraw.
				<Button
					size="sm"
					variant="secondary"
					className="w-fit"
					isLoading={isSubmitting}
					onClick={handleWithdrawUnstakedAssets}
				>
					<span>
						Withdraw {existingUnstakeRequestAmount?.toFixed(displayPrecision)}
					</span>
					{selectedMarket.symbol}
				</Button>
			</InlineAlert>
		);
	}

	return (
		<InlineAlert variant="info" title="Unstake request in progress">
			You have an unstake request in progress.
			{existingUnstakeRequestAmount?.toFixed(displayPrecision)}{' '}
			{selectedMarket.symbol} will be available to withdraw on{' '}
			{printDate(existingUnstakeRequestTimestamp)}
			{hasExistingUnstakeRequest && (
				<Button
					size="sm"
					variant="secondary"
					className="w-fit"
					onClick={handleCancelUnstakeRequest}
					isLoading={isSubmitting}
				>
					Cancel unstake request
				</Button>
			)}
		</InlineAlert>
	);
}
